import { Tabs } from '@ui';
import React from 'react';
import { ProgramTabsSC } from './program-tabs.styled';

type TProps = {
  selected: number;
  onChange(v: number): void;
  options: { key: string; label: string }[];
};

const ProgramTabs: React.FC<TProps> = ({ onChange, selected, options }) => {
  return (
    <ProgramTabsSC>
      <Tabs
        items={options}
        activeKey={`${selected}`}
        onChange={(k) => {
          onChange(Number(k));
        }}
      />
    </ProgramTabsSC>
  );
};

export default ProgramTabs;
